import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';

// Define an InjectionToken for the PvUserService
const PV_USER_SERVICE = new InjectionToken('Pv User Service');
/**
 * The base class which will be implemented by the client application
 *
 * The client application will override the method which will send the configuration for a particular view or it's subset for consumption within that view's component
 */
class PvUserService {
    constructor() {
        // Subject for user login/logout events
        this.userLoggedIn$ = new Subject();
        this.userCardSelected$ = new Subject();
        // Observable for user login/logout events
        this.userLoggedInObservable$ = this.userLoggedIn$.asObservable();
        this.userCardSelectedObservable$ = this.userCardSelected$.asObservable();
        // Subject for authentication modal open/close events
        this.loginModal$ = new Subject();
        // Observable for authentication modal open/close events
        this.loginModalObservable$ = this.loginModal$.asObservable();
        // Subject for token expiration events
        this.tokenExpired$ = new Subject();
        // Observable for token expiration events
        this.tokenExpiredObservable$ = this.tokenExpired$.asObservable();
    }
    /**
     * Notifies subscribers of user login or logout.
     * @param isLoggedIn A boolean indicating whether the user is logged in.
     */
    notifyUserLogin(isLoggedIn) {
        this.userLoggedIn$.next(isLoggedIn);
    }
    /**
     * Notifies subscribers of user card selection.
     * @param isSelected A boolean indicating whether the user selected a card.
     */
    notifyUserCardSelected(isSelected) {
        this.userCardSelected$.next(isSelected);
    }
    /**
     * Notifies subscribers to open or close the authentication modal.
     * @param open A boolean indicating whether to open or close the modal.
     */
    toggleAuthModal(open) {
        this.loginModal$.next(open);
    }
    // COMMENT: will be consuming tokenExpired$ to upadte token and update tokenEXpiry flag in session/localStorage.
    /**
     * Notifies subscribers of token expiration.
     * @param tokenExpired A boolean indicating whether the token has expired.
     */
    updateTokenExpiry(tokenExpired) {
        this.tokenExpired$.next(tokenExpired);
    }
    // Method to set login auth code details
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setLoginAuthCodeDetails(LoginAuthCode) {
        throw new Error('Method not implemented');
    }
    // Method to get login auth code details
    getLoginAuthCodeDetails() {
        throw new Error('Method not implemented');
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { PV_USER_SERVICE, PvUserService };
